import { Title } from "./style";

interface Props {
  text: string;
}

export function CompositeContainerTitulo({ text }: Props) {
  return <Title>{text}</Title>;
}
